{
  "breadcrumbAriaLabel": "ब्रेडक्रंब",
  "homeAriaLabel": "होम",
  "mainNavAriaLabel": "मुख्य नेविगेशन",
  "closeSidebarAriaLabel": "साइडबार बंद करें",
  "collapse": "संक्षिप्त करें",
  "help": "सहायता",
  "settings": "सेटिंग्स",
  "myProfile": "मेरी प्रोफ़ाइल",
  "groups": {
    "clinical": "नैदानिक",
    "worklists": "कार्य सूची",
    "documentation": "नैदानिक दस्तावेज़",
    "orders": "चिकित्सा आदेश",
    "medications": "दवाएं",
    "scheduling": "अपॉइंटमेंट प्रबंधन",
    "billing": "बिलिंग",
    "analytics": "विश्लेषण",
    "organization": "संगठन",
    "security": "सुरक्षा",
    "accessReviews": "Access Reviews",
    "integrations": "एकीकरण",
    "system": "सिस्टम",
    "licensing": "लाइसेंस"
  },
  "dashboard": "डैशबोर्ड",
  "patients": "रोगी",
  "patientSearch": "रोगी खोजें",
  "myPatients": "मेरे रोगी",
  "censusBedBoard": "भर्ती रोगी / बेड बोर्ड",
  "providerDirectory": "चिकित्सक निर्देशिका",
  "providerCoverage": "चिकित्सक ड्यूटी कवरेज",
  "patientMerge": "रोगी रिकॉर्ड विलय",
  "inbox": "इनबॉक्स",
  "pendingResults": "लंबित परिणाम",
  "criticalResults": "गंभीर परिणाम",
  "unsignedNotes": "अहस्ताक्षरित नोट्स",
  "cosignQueue": "सह-हस्ताक्षर कतार",
  "noteTemplates": "नोट टेम्पलेट",
  "smartPhrases": "स्मार्ट वाक्यांश",
  "orderCatalog": "आदेश सूची",
  "orderSets": "आदेश सेट",
  "encounters": "चिकित्सा भेंट",
  "orders": "चिकित्सा आदेश",
  "results": "परिणाम",
  "medications": "दवाएं",
  "notes": "चिकित्सा नोट्स",
  "medicationWorklist": "Medication Worklist",
  "formulary": "औषधि सूची",
  "pharmacistQueue": "फार्मासिस्ट कतार",
  "appointments": "अपॉइंटमेंट",
  "scheduleManagement": "शेड्यूल प्रबंधन",
  "waitlist": "प्रतीक्षा सूची",
  "charges": "शुल्क",
  "claims": "दावे",
  "payments": "भुगतान",
  "accounts": "खाते",
  "statements": "विवरण",
  "denials": "अस्वीकृति",
  "analyticsDashboard": "डैशबोर्ड",
  "reports": "रिपोर्ट",
  "qualityMeasures": "गुणवत्ता मापदंड",
  "healthSystems": "स्वास्थ्य प्रणाली",
  "facilities": "सुविधाएं",
  "locations": "स्थान",
  "clinicalTaxonomy": "नैदानिक वर्गीकरण",
  "serviceLocation": "सेवा ↔ स्थान",
  "providers": "चिकित्सक",
  "users": "उपयोगकर्ता",
  "roles": "भूमिकाएं",
  "accessMatrix": "एक्सेस मैट्रिक्स",
  "integrations": "एकीकरण",
  "thirdPartyApps": "तृतीय-पक्ष ऐप्स",
  "audit": "ऑडिट",
  "system": "सिस्टम",
  "cdsRules": "CDS नियम",
  "escalationRules": "Escalation Rules",
  "segments": {
    "search": "खोज",
    "register": "पंजीकरण",
    "demographics": "जनसांख्यिकी",
    "census": "भर्ती रोगी",
    "discharge": "डिस्चार्ज",
    "catalog": "सूची",
    "sets": "आदेश सेट",
    "pending": "लंबित",
    "critical": "गंभीर",
    "reconciliation": "औषधि मिलान",
    "worklist": "कार्य सूची",
    "templates": "टेम्पलेट",
    "smartPhrases": "स्मार्ट वाक्यांश",
    "schedule": "शेड्यूल प्रबंधन",
    "quality": "गुणवत्ता मापदंड",
    "administration": "प्रशासन",
    "auditLog": "ऑडिट लॉग",
    "allergies": "एलर्जी",
    "problems": "समस्या सूची",
    "immunizations": "टीकाकरण",
    "insurance": "बीमा"
  },
  "handoffs": "हैंडऑफ़",
  "duplicateReview": "डुप्लिकेट समीक्षा",
  "sso": "SSO & Directories",
  "userGroups": "User Groups",
  "fileKey": "File key",
  "ordersWorklist": "आदेश कार्यसूची"
}
